<template>
    <form @submit.prevent="onSubmit"
          class="row gutter-sm"
          @keydown="form.onKeydown($event)">

        <div class="col-12 row justify-center q-mt-md" id="title">Verificação de nº de telemóvel</div>

        <!-- Submit Button -->
        <div class="col-12 row justify-center q-mt-md">
            <v-input :maxlength="9" path="phone"
                     v-model="form.phone"
                     :label="$t('cell phone')"
                     :form="form"
                     class="col-md-4 col-sm-6 col-xs-12">
            </v-input>
        </div>
        <div class="col-12 row justify-center q-mt-md">
            <v-button outline
                      :label="$T('save')"
                      icon="save"
                      color="highlight"
                      class="no-shadow uppercase q-btn-iqos"
                      :disable="form.busy"
                      :loading="form.busy"
                      type="submit">
                <template slot="loading">
                    <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                    {{ $T('saving...') | capitalize }}
                </template>
            </v-button>
        </div>

        <order-detail :item="item" :show="modalDetail" @close="modalDetail=false" @updated="refreshList"></order-detail>
    </form>
</template>

<script>
    import Form from "vform";
    import orderModel from "../pages/orderModel";
    import axios from "axios";
    import orderDetail from "../pages/_orderDetail";

    export default {
        name: "phoneValidation",

        components: {
            orderDetail,
        },

        props: {
            detailComp: String
        },

        data() {
            return {
                form: new Form(orderModel.data().orderModel),
                modalDetail: false,
                item: {}
            }
        },

        methods: {
            async onSubmit() {
                let response = await this.form.post(`/api/v1/lending-point/preorder`)
                if (!response.data) return

                let {data} = response
                this.form = new Form(this.orderModel)

                if (data.completedNotReturned) {
                    this.$q.notify(data.message)
                    return
                }

                if(data.redirectToDetail) {
                    let orderId = data.orderId
                    let order = await axios.get('/api/order/'+orderId)

                    if(order.data.model) {

                        this.modalDetail = true
                        this.item = order.data.model
                        if(order.data.model.order_status_id === 1) {
                            this.item ['order_status.description'] = 'Reserved';
                        }
                    }
                }else {

                    if(data.sms) {
                        this.form.phone = data.phone;

                        this.$q.dialog({
                            title: 'Código de confirmação',
                            preventClose: true,
                            color: 'primary',
                            stackButtons: true,
                            cancel: true,
                            prompt: {
                                model: '',
                                type: 'text', // optional
                            },
                        }).then(async (token) => {
                            if(token !== '') {
                                this.form.smsCode = token;
                                this.form.phone = data.phone;

                                let response = await this.form.post(`/api/v1/lending-point/smsCodeValidation`);

                                if(response.data.result) {
                                    this.$emit('show-form-lending-creation', {'result': true, 'phone': this.form.phone})
                                }else {
                                    this.$q.notify(`${response.data.errorMessage}`)
                                }
                            }else{
                                this.$q.notify(`Por favor insira um código válido.`)
                            }
                        }).catch(() => {});
                    } else {
                        this.$q.notify(`${data.smsErrorMessage}`)
                    }
                }
            },

            refreshList() {
                this.$refs.list.refreshRows()
            }
        },
    }

</script>

<style scoped>
    #title {
        font-size: 1.5em;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/PhoneValidation.vue